import { Spinner, Stack, Text } from "@shopify/polaris";
import EmptyPage from "./EmptyPage.js";
import { RefreshMinor } from "@shopify/polaris-icons";
import { notFoundImage, ok_icon, searchIcon } from "../../../../../../../assets/index.js";

const EmptyTable = ({ shop, actions, queryValue, handleSync, handleCreateAction }) => {
  if (actions.length === 0 && queryValue) {
    return (
      <Stack spacing="loose" vertical alignment="center">
        <img src={searchIcon} width={50} height={50} alt="No items found" />
        <Stack spacing="loose" vertical alignment="center">
          <Text as="h2" variant="headingXl">No Items found</Text>
          <Text as="p" variant="bodyLg" color="subdued">Try changing the filters or search term</Text>
        </Stack>
      </Stack>
    );
  }
  switch (shop?.synchronizationStatus) {
    case "waiting":
      return (
        <EmptyPage
          image={searchIcon}
          handleSync={handleSync}
          icon={shop?.synchronizationStatus === "processing" ? <Spinner size="small" /> : RefreshMinor}
          message={"The first time you run it, you'll need to synchronize items with your store. The more products you have, the longer it will take."}
          wait={"Please wait until the process is finished."}
        />
      )
    case ("processing" || "loading"):
      return (
        <EmptyPage
          image={notFoundImage}
          message={"Currently synchronizing, please wait until Sync is complete."}
        />
      )
    case "failed":
      return (
        <EmptyPage
          image={notFoundImage}
          handleSync={handleSync}
          icon={shop?.synchronizationStatus === "processing" ? <Spinner size="small" /> : RefreshMinor}
          message={"Failed sync, please try synchronizing again."}
          wait={"Please wait until the process is finished."}
        />
      )
    case "completed":
      return (
        <EmptyPage
          img={ok_icon}
          handleCreateAction={handleCreateAction}
          message={"You are all set! Now you can create a new action."}
        />
      )
    default:
      return null
  }
}

export default EmptyTable;
